import React from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import {Box, Heading, Text} from '@tenancy.nz/ui';
import {motion} from 'motion/react';

function BookingSuccess({
  address = undefined,
  viewingDate = undefined,
  viewingTime = undefined,
}) {
  return (
    <motion.div>
      <Box sx={{display: 'flex', justifyContent: 'center'}}>
        <Box
          sx={{
            bgcolor: 'common.white',
            maxWidth: 360,
            width: '100%',
            p: 8,
            borderRadius: '10px',
            boxShadow: '0 0 12.457px rgba(0, 0, 0, 0.1)',
          }}>
          <Stack gap={4} alignItems="center">
            <Heading as="h3" align="center">
              Your booking has been submitted
            </Heading>
            <Text align="center" sx={{fontSize: 14}}>
              Your viewing time has been submitted. You will receive an email
              shortly with your viewing details.
            </Text>
            {address && (
              <Text align="center" sx={{fontSize: 14}}>
                Property address:
                <br />
                <strong>{address}</strong>
              </Text>
            )}
            {viewingDate && viewingTime && (
              <Box
                sx={{
                  display: 'flex',
                  gap: 4,
                  justifyContent: 'center',
                  width: '100%',
                }}>
                <Text sx={{fontSize: 14}}>
                  Date: <strong>{viewingDate}</strong>
                </Text>
                <Text sx={{fontSize: 14}}>
                  Time: <strong>{viewingTime}</strong>
                </Text>
              </Box>
            )}
          </Stack>
        </Box>
      </Box>
    </motion.div>
  );
}

BookingSuccess.propTypes = {
  address: PropTypes.string,
  viewingDate: PropTypes.string,
  viewingTime: PropTypes.string,
};

export default BookingSuccess;
